import React, { Fragment } from "react";
import styles from "./show_paginate_text.module.scss";

const ShowPaginateText = ({ paginate, ...props }) => {
  const showingfrom =
    paginate.total > 0
      ? parseInt(parseInt(paginate.currentPage) - 1) *
          parseInt(paginate.limit) +
        1
      : 0;

  const showingTo =
    parseInt(paginate.limit) > parseInt(paginate.page_total)
      ? parseInt(paginate.total)
      : parseInt(paginate.currentPage) * parseInt(paginate.limit) <=
        parseInt(paginate.total)
      ? parseInt(paginate.currentPage) * parseInt(paginate.limit)
      : parseInt(paginate.total);

  return (
    <Fragment>
      {paginate ? (
        <div className={`${styles.shwing_num}`}>
          Showing {showingfrom} to {showingTo} of {parseInt(paginate.total)}{" "}
          {props.name ? props.name : `entries`}
        </div>
      ) : (
        <></>
      )}
    </Fragment>
  );
};

export default ShowPaginateText;
